import React, { useEffect, useState } from "react";
import BlogCardsRow from "../components/BlogCardsRow";
import HeroImageSection from "../components/HeroImageSection";
import solarservices from "../assets/solarservice.jpeg";
import { Helmet } from "react-helmet-async";
import { fetchBlogsFromWp } from "../data/wpApi";

// PROTOTYPE: fetches from a local headless WordPress instance instead of
// the static src/data/BlogsData.jsx array, to test whether WP can back
// this exact page with no visual differences. See src/data/wpApi.js.
const BlogPage = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchBlogsFromWp(solarservices)
      .then(setBlogs)
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-white">
<Helmet>
  <title>Solar Energy Blog | Tips, Trends & Guides | Savorka</title>

  <meta
    name="description"
    content="Read Savorka’s solar blog for expert tips, industry trends, and guides on solar panels, renewable energy & cost-saving solutions."
  />

  <link
    rel="canonical"
    href="https://www.savorka.in/blogs"
  />

  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Savorka Blog",
      "url": "https://www.savorka.in/blogs",
      "description":
        "Explore the latest blogs on solar energy, rooftop solar systems, ground-mounted solutions, and energy-saving tips by Savorka.",
      "publisher": {
        "@type": "Organization",
        "name": "Savorka",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.savorka.in/path-to-logo.png"
        }
      },
      "inLanguage": "en-IN"
    })}
  </script>
</Helmet>
      <HeroImageSection
        title="OUR BLOGS"
        heroImage={solarservices}
        altText="Savorka Solar blog"
      />

      <section className="px-5 py-12">
        {loading && (
          <p className="text-center text-[#7c8798]">Loading posts…</p>
        )}
        {error && (
          <p className="text-center text-red-600">
            Couldn’t load posts from WordPress: {error}
          </p>
        )}
        {!loading && !error && <BlogCardsRow blogs={blogs} />}
      </section>

    </div>
  );
};

export default BlogPage;
